module.exports = __webpack_public_path__ + "static/uvodniFoto.9a6a85f8.png";